/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react';
import { graphql } from 'gatsby';
import * as PropTypes from 'prop-types';
import SEO from '../components/SEO';
import BadgeHeroSection from '../components/HeroSectionBadge';
import ArticleContainer from '../components/Article';
import GetSEOData from '../data/SEO';
import StructuredMarkup from '../components/StructuredMarkup';
const propTypes = {
  data: PropTypes.object.isRequired,
};

const NewsTemplate = ({ data, pageContext }) => {
  const newsData = data.datoCmsNewsArticleModel;
  const allNewsData = data.allDatoCmsNewsArticleModel.nodes;
  const { previous, next, slug: currentSlug } = pageContext;

  const dateOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  let { title, description } = GetSEOData(`news`);
  return (
    <>
      <StructuredMarkup
        type="BlogPosting"
        headline={newsData.seoTitle}
        url={`/news/${currentSlug}/`}
        datePublished={new Date(newsData?.publishedDate).toLocaleString(
          [],
          dateOptions,
        )}
        articleBody={newsData.content}
        image={newsData.newsArticleHero[0]?.heroImageDesktop}
      />
      <div className="bootstrap">
        <div className="news-container">
          <SEO
            title={newsData.seoTitle ?? title}
            description={newsData.seoDescription ?? description}
            canonical={`news/${currentSlug}`}
            metaTags={newsData?.seoContent}
          />
          <BadgeHeroSection
            heading={newsData.newsArticleHero[0]?.heading}
            mode={newsData.newsArticleHero[0]?.mode}
            layout={newsData.newsArticleHero[0]?.layout}
            smallHeading={new Date(newsData?.publishedDate).toLocaleString(
              [],
              dateOptions,
            )}
            secondaryHeroImage={newsData.newsArticleHero[0]?.heroImageDesktop}
            hidePostcodeSearch
          />
          <ArticleContainer
            data={allNewsData}
            content={newsData.content}
            currentSlug={currentSlug}
            dateOptions={dateOptions}
            previous={previous}
            next={next}
            pageSlug={'news'}
            defaultImage={data.defaultImage}
          />
        </div>
      </div>
    </>
  );
};

NewsTemplate.propTypes = propTypes;

export default NewsTemplate;
export const pageQuery = graphql`
  query ($id: String!) {
    datoCmsNewsArticleModel(id: { eq: $id }) {
      seoContent {
        description
        title
        twitterCard
        image {
          gatsbyImageData
        }
      }
      ...NewsRecordLink
      title
      slug
      newsArticleHero {
        heading {
          value
        }
        layout
        mode
        heroImageDesktop {
          gatsbyImageData
        }
      }
      contentWordCounter
      content {
        value
      }
      category {
        name
      }
      publishedDate
      seoTitle
      seoDescription
    }

    allDatoCmsNewsArticleModel(
      filter: { id: { ne: $id } }
      sort: { fields: publishedDate, order: DESC }
    ) {
      nodes {
        title
        slug
        previewImage {
          gatsbyImageData
        }
        previewText
        content {
          value
        }
        publishedDate
        category {
          name
        }
      }
    }

    defaultImage: file(relativePath: { eq: "news-images/news_default.jpg" }) {
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
        fixed {
          src
        }
      }
    }
  }
`;
export const fragment = graphql`
  fragment NewsRecordLink on DatoCmsNewsArticleModel {
    content {
      blocks {
        __typename
        ... on DatoCmsPostcodeCheckerCallToAction {
          id: originalId
          buttonText
          isModal
        }
        ... on DatoCmsInlineIdContent {
          id: originalId
          idContent
          text
        }
      }
      value
      links {
        __typename
        ... on DatoCmsMediaModel {
          id: originalId
          media {
            url
            gatsbyImageData
            mimeType
          }
        }
        ... on DatoCmsBlogArticleModel {
          id: originalId
          slug
        }
        ... on DatoCmsNewsArticleModel {
          id: originalId
          slug
        }
        ... on DatoCmsModularPage {
          id: originalId
          slug
        }
        ... on DatoCmsSimpleWebsitePageModel {
          id: originalId
          slug
        }
      }
    }
  }
`;
